import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { download } from "utils/http";

function BookingFormButton({ invoiceNumber, shipmentId }) {
  const [loading, setLoading] = useState(false);

  function onClickHandler() {
    setLoading(true);
    download(
      `/shipment/${shipmentId}/booking-form/xlsx/`,
      `BookingForm-${invoiceNumber.replace("/", "_")}.xlsx`,
      {},
    )
      .catch((err) => Alert("error", String(err)))
      .finally(() => setLoading(false));
  }

  return (
    <Button loading={loading} onClick={onClickHandler}>
      {loading ? "Exporting..." : "Booking Form"}
    </Button>
  );
}

export default BookingFormButton;
